
export default "/assets/trash-micro.75c68ce5.svg"